import React from "react";
import { IoLocationOutline } from "react-icons/io5";
import { useLanguage } from "../LanguageContext";
import useScrollReveal from "../../utils/useScrollReveal";

import "../../assets/css/about.css";
import "../../assets/css/font.css";
import profilePicture from "../../assets/img/profile.jpg";

function About() {
  const { t } = useLanguage();
  const [ref, visible] = useScrollReveal();

  return (
    <section
      id="about"
      ref={ref}
      className={`section about reveal ${visible ? "is-visible" : ""}`}
    >
      <div className="container about-grid">
        <div className="about-copy">
          <span className="eyebrow">{t.about.eyebrow}</span>
          <h2 className="section-heading">{t.about.title}</h2>
          <p className="about-subtitle">{t.about.subtitle}</p>
          <span className="about-location mono">
            <IoLocationOutline />
            {t.about.location}
          </span>
          <p className="about-text">{t.about.text1}</p>
          <p className="about-text">{t.about.text2}</p>

          <div className="about-facts">
            <div className="about-fact-block">
              <h3>{t.about.educationTitle}</h3>
              <div className="about-fact-item">
                <strong>{t.about.masters}</strong>
                <span className="about-fact-meta mono">Universidade Federal de Goiás (UFG) · 2020–2022</span>
              </div>
              <div className="about-fact-item">
                <strong>{t.about.bachelors}</strong>
                <span className="about-fact-meta mono">Universidade Federal de Goiás (UFG) · 2014–2019</span>
              </div>
            </div>

            <div className="about-fact-block">
              <h3>{t.about.languagesTitle}</h3>
              {t.about.languages.map((language) => (
                <div className="about-fact-item about-fact-inline" key={language.name}>
                  <span>{language.name}</span>
                  <span className="about-fact-meta mono">{language.level}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="about-portrait">
          <img src={profilePicture} alt="Retrato de Vinícius Gabriel" />
        </div>
      </div>
    </section>
  );
}

export default About;
